function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    $(".select-error").remove();
    var proceed = true;
    $(".custom-variant-options")
      .find(".select__select")
      .css({ border: "0px solid #d61536" });
    $("variant-selects").parent(".variant-block-container").css({
      border: "0px solid #d61536",
      "border-top-right-radius": "10px",
      "border-top-left-radius": "10px",
    });

    $("variant-selects").each(function () {
      if ($(this).find("select").val() == "select") {
        proceed = false;
        $(".custom-variant-options")
          .find(".select__select")
          .css({ border: "2px solid #d61536" });
        $("variant-selects")
          .parent(".variant-block-container")
          .css({ border: "2px solid #d61536", "border-radius": "0px" });
      }
    });
    $("variant-radios").each(function () {
      if ($("variant-radios").find("input:checked").length == 0) {
        proceed = false;
      }
    });

    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    if (proceed == false) {
      return;
    } else {
      $("variant-radios").css("pointer-events", "initial");
    }

    this.toggleAddButton(true, "", false);
    //this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(document.querySelectorAll("fieldset"));
    const varselects = Array.from(document.querySelectorAll("variant-selects"));

    var option1 = [];

    fieldsets.forEach((fieldset, index) => {
      if (fieldset.querySelectorAll("input[type='radio']").length > 0) {
        option1.push(
          Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value
        );
      }
      console.log(fieldset.querySelectorAll("select").length);
      if (fieldset.querySelectorAll("select").length > 0) {
        option1.push(fieldset.querySelectorAll("select")[0].value);
      }
    });
    varselects.forEach((varselect, index) => {
      console.log(varselect.querySelectorAll("select").length);
      if (varselect.querySelectorAll("select").length > 0) {
        option1.push(varselect.querySelectorAll("select")[0].value);
      }
    });
    this.options = option1;
    console.log(this.options);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if ($("custom-slider").length > 0) {
      var count = 0;
      var cindex = 0;

      $(this).parent().addClass("active");
      $(".thumb-slider .swiper-slide:visible").each(function (index) {
        if ($(this).hasClass("active")) {
          cindex = count;
        }
        count++;
      });

      var varid = "";
      if (!this.currentVariant) {
        varid = $('variant-radios[data-option="color"] input:checked').data(
          "var"
        );
      } else {
        varid = this.currentVariant.id;
      }
      console.log(
        $(".product__media-gallery")
          .find('.swiper-slide[data-color="' + varid + '"]')
          .eq(0)
          .find("img")
          .attr("src")
      );
      if ($('variant-radios[data-option="color"]').length != 0) {
        $('variant-radios[data-option="color"] .form__label').text(
          "Color : " +
            $('variant-radios[data-option="color"] input:checked').val()
        );
      }
      var index = $(".thumb-slider").index($(".swiper-slide.active"));
      $(".product__media-gallery").find(".swiper-slide").hide();
      $(".product__media-gallery")
        .find('.swiper-slide[data-color="' + varid + '"]')
        .show();

      var fimg =
        "https:" +
        $(".product__media-gallery")
          .find('.swiper-slide[data-color="' + varid + '"]')
          .eq(0)
          .find("img")
          .attr("src");
      $('input[name="properties[_Image]"]').attr("value", fimg);

      $(".thumb-slider .swiper-slide").removeClass("active");

      $(".thumb-slider .swiper-slide:visible").eq(cindex).addClass("active");
    }
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    var option1 = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    var option2 = Array.from(
      document.querySelectorAll(".select__select"),
      (select) => select.value
    );
    this.options = option1.concat(option2);
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class CarCover extends HTMLElement {
  constructor() {
    super();
    var csvurl = $(".car-cover-main-container").data("csvfile");
    var jsonarr = [];

    $.ajax({
      type: "GET",
      url: csvurl,
      dataType: "text",
      success: function (data) {
        var csvData = data;
        let word_array = $.csv.toArrays(csvData);

        for (let index = 1; index < word_array.length; index++) {
          var ob = {};
          ob["category"] = word_array[index][0];
          ob["year"] = word_array[index][1];
          ob["make"] = word_array[index][2];
          ob["model"] = word_array[index][3];
          ob["brand"] = word_array[index][4];
          jsonarr.push(ob);
        }
        setDataInPage(jsonarr);
      },
    });

    function setDataInPage(jsonarr) {
      console.log("dsdsdsd");
      var strpart = $(".car-cover-main-container").data("strpart");
      var curl = $(".car-cover-main-container").data("url");
      var colltitle = $(".car-cover-main-container").data("title");
      var collprotitle = $(".car-cover-main-container").data("protitle");

      var years = [];
      $.each(jsonarr, function (index, value) {
        if ($.inArray(value.year, years) === -1) {
          years.push(value.year);
        }
      });
      loadData(years);

      function loadData(years) {
        years.sort();
        years.reverse();
        var stryear =
          '<option value="Select Year" disabled selected>Select Year</option>';
        for (var i = 0; i < years.length; i++) {
          var yy = years[i];
          stryear =
            stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
        }
        $(".yearselect").html(stryear);
        $(".yearselect").removeAttr("disabled");
        $(".yearselect").change(function () {
          $(".yearselect").val($(this).val());
          $(".amfinder-reset").show();

          $(".modelselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(".makeselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );

          var makes = [];
          var selyear = $(this).val();
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year == selyear) {
                makes.push(value.make);
              }
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var valma = ma.replace(".", "");
            valma = valma.replace("'", "");
            valma = valma.replace('"', "");
            strmake =
              strmake + `<option value='${valma}'>${ma.split("_")[1]}</option>`;
          }
          $(".makeselect").html(strmake);
          $(".makeselect").removeAttr("disabled");
          $(".modelselect").html(
            '<option value="Select Model" disabled selected>Select Model</option>'
          );
          $(".modelselect").attr("disabled", true);
        });
        $(".makeselect").change(function () {
          $(".makeselect").val($(this).val());
          $(".amfinder-reset").show();
          console.log($(this).val());
          var models = [];
          var selyear = $(this)
            .parents(".select-wrapper")
            .find(".yearselect")
            .val();
          var selmake = $(this).val();
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.year == selyear && value.make == selmake) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            console.log(models[i]);
            var mo = models[i];
            var valmo = mo.replace(".", "");
            valmo = valmo.replace("'", "");
            valmo = valmo.replace('"', "");
            modelhtml =
              modelhtml +
              `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");
        });

        $(".modelselect").change(function () {
          $(".modelselect").val($(this).val());
          $(".search--button").removeAttr("disabled");
        });

        //$(".search--button").click(function ()
        $(".modelselect").change(function () {
          $(".modelselect").val($(this).val());
          var yearc = $(this)
            .parents(".select-wrapper")
            .find(".yearselect")
            .val()
            .replace(".", "")
            .replace("&", "%26")
            .toLowerCase();
          var makec = $(this)
            .parents(".select-wrapper")
            .find(".makeselect")
            .val()
            .replace(".", "")
            .replace("&", "%26")
            .toLowerCase();
          makec = makec.replace("/", "-");
          var modelc = $(this)
            .parents(".select-wrapper")
            .find(".modelselect")
            .val()
            .replace(".", "")
            .replace("&", "%26")
            .toLowerCase();
          var smodelc = modelc.split("/").join("-");
          var strpartn =
            yearc.split(" ").join("-") +
            "+" +
            makec.split(" ").join("-") +
            "+" +
            smodelc.split(" ").join("-");
          $(".amfinder-reset").show();
          $(".before-reset").hide();
          $(".after-reset").show();
          $(".view-all-cover").hide();
          $("html").css("overflow", "auto");

          $(".after-reset").css("text-align", "center");
          $(".after-reset").html(
            '<img style="text-align:center;width:60px;height:60px;margin:10rem auto 5rem;" src="https://cdn.shopify.com/s/files/1/0626/2105/7254/files/loading-gif.gif"/>'
          );

          loadProductData();
          function loadProductData() {
            fetch("/collections/all/" + strpartn)
              .then((response) => response.text())
              .then((responseText) => {
                const html = responseText;
                var elem = new DOMParser()
                  .parseFromString(html, "text/html")
                  .getElementsByClassName("after-reset")[0];
                if (elem) {
                  var htmlmake = new DOMParser()
                    .parseFromString(html, "text/html")
                    .getElementsByClassName("after-reset")[0].innerHTML;
                  $(".after-reset").html(htmlmake);
                  $(".after-reset").css("text-align", "initial");
                  $(".category-products").click(function () {
                    $(this).next().toggle();
                    $(this).children(".header-box").toggleClass("opened");
                  });
                  $(".currenttag").html(
                    yearc.split("_")[1] +
                      " " +
                      makec.split("_")[1] +
                      " " +
                      modelc.split("_")[1] +
                      " " +
                      colltitle
                  );

                  $(".currenttagfit").html(
                    yearc.split("_")[1] +
                      " " +
                      makec.split("_")[1] +
                      " " +
                      modelc.split("_")[1]
                  );

                  $(".currcolltag").html(collprotitle);

                  window.history.replaceState(
                    {},
                    null,
                    curl +
                      "?year=" +
                      yearc.split("_")[1] +
                      "&make=" +
                      makec.split("_")[1].replace("&", "%26") +
                      "&model=" +
                      modelc.split("_")[1].replace("&", "%26")
                  );
                  $(".featured-swatch").click(function () {
                    $(".featured-swatch").removeClass("active");
                    $(this).addClass("active");
                    $(".category-products-all").hide();
                    $(
                      '.category-products-all[data-handle="' +
                        $(this).data("handle") +
                        '"]'
                    ).show();
                  });
                  $(".amfinder-reset").click(function () {
                    window.location.href = curl;
                  });
                  var searchP = new URLSearchParams(window.location.search);
                  var brandn = searchParams.get("brand");
                  if (
                    $(
                      '.swiper-slide.featured-swatch[data-handle="' +
                        brandn +
                        '"]'
                    ).length > 0
                  ) {
                    $(
                      '.swiper-slide.featured-swatch[data-handle="' +
                        brandn +
                        '"]'
                    ).trigger("click");
                    $(".swiper-slide.featured-swatch").removeClass("active");
                    $(
                      '.swiper-slide.featured-swatch[data-handle="' +
                        brandn +
                        '"]'
                    ).addClass("active");
                  }
                  $("html, body").animate(
                    {
                      scrollTop: $("#richtext-collection").offset().top,
                    },
                    1500
                  );
                } else {
                  loadProductData();
                }

                $(".readmore").on("click", function () {
                  var $content = $(this).parent();
                  var isExpanded = $content.hasClass("expanded");

                  if (isExpanded) {
                    $content.removeClass("expanded");
                    $(this).text("Read More");
                  } else {
                    $content.addClass("expanded");
                    $(this).text("Read Less");
                  }
                });
                $(".custom-product-color-item").click(function () {
                  $(this)
                    .parents(".custom-product-item-image-container")
                    .find(".image img")
                    .attr("src", $(this).data("image"));
                });
              })
              .catch((error) => {
                loadProductData();
              });
          }
        });

        var yeartag = "";
        var maketag = "";
        var modeltag = "";

        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has("year")) {
          yeartag = searchParams.get("year").split("-").join(" ").toUpperCase();
        }
        if (searchParams.has("make")) {
          maketag = searchParams.get("make").split("-").join(" ").toUpperCase();
        }
        if (searchParams.has("model")) {
          modeltag = searchParams.get("model").toUpperCase();
        }

        console.log(yeartag);
        console.log(maketag);
        console.log(modeltag);

        if (yeartag != "") {
          $(".yearselect").val("YEAR_" + yeartag);
        }

        if (maketag != "") {
          $(".amfinder-reset").show();

          $(".modelselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(".makeselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );

          var makes = [];
          var yearnow = "YEAR_" + yeartag;
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year == yearnow) {
                makes.push(value.make);
              }
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            var valma = ma.replace(".", "");
            valma = valma.replace("'", "");
            valma = valma.replace('"', "");
            valma = valma.toUpperCase();
            strmake =
              strmake + `<option value='${valma}'>${ma.split("_")[1]}</option>`;
          }
          $(".makeselect").html(strmake);
          $(".makeselect").removeAttr("disabled");
          $(".makeselect").val("MAKE_" + maketag);
        }

        if (modeltag != "") {
          $(".modelselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(".amfinder-reset").show();
          var models = [];

          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              var yearnow = "YEAR_" + yeartag;
              var makenow = "MAKE_" + maketag;
              var cmakenow = value.make.replace("'", "");
              cmakenow = cmakenow.replace('"', "");
              //cmakenow = cmakenow.replace('%26', "&");
              cmakenow = cmakenow.toUpperCase();
              if (value.year == yearnow && cmakenow == makenow) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            var mo = models[i];
            var valmo = mo.replace(".", "");
            valmo = valmo.replace("'", "");
            valmo = valmo.replace('"', "");
            valmo = valmo.toUpperCase();
            modelhtml =
              modelhtml +
              `<option value='${valmo}'>${mo.split("_")[1]}</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");
          $(".modelselect").val("MODEL_" + modeltag);

          console.log(modeltag);

          var yearc = "Year_" + yeartag.replace(".", "");
          var makec = "Make_" + maketag.replace(".", "");
          makec = makec.replace("/", "-");
          // makec = makec.replace("&", "%26");
          var modelc = "Model_" + modeltag.replace(".", "");
          modelc = modelc.split("/").join("-");
          // modelc = modelc.replace("&", "%26");
          var partn =
            yearc.split(" ").join("-").toLowerCase() +
            "+" +
            makec.split(" ").join("-").toLowerCase() +
            "+" +
            modelc.split(" ").join("-").toLowerCase();

          $(".currenttag").html(
            yeartag + " " + maketag + " " + modeltag + " " + colltitle
          );

          $(".currenttagfit").html(yeartag + " " + maketag + " " + modeltag);

          $(".currcolltag").html(collprotitle);

          $(".after-reset").css("text-align", "center");
          $(".after-reset").html(
            '<img style="text-align:center;width:60px;height:60px;margin:10rem auto 5rem;" src="https://cdn.shopify.com/s/files/1/0626/2105/7254/files/loading-gif.gif"/>'
          );

          var tagsmatch = false;
          var matchyear = "YEAR_" + yeartag;
          var matchmake = "MAKE_" + maketag;
          var matchmodel = "MODEL_" + modeltag;
          if (
            matchyear == localStorage.getItem("year") &&
            matchmake == localStorage.getItem("make") &&
            matchmodel == localStorage.getItem("model")
          ) {
            tagsmatch = true;
          }

          if (
            localStorage.getItem("afterdata") != null &&
            localStorage.getItem("afterdata") != "" &&
            tagsmatch == true
          ) {
            $(".after-reset").html(localStorage.getItem("afterdata"));
            localStorage.clear();
            $(".after-reset").css("text-align", "initial");
            $(".category-products").click(function () {
              $(this).next().toggle();
              $(this).children(".header-box").toggleClass("opened");
            });

            $(".currenttag").html(
              yeartag + " " + maketag + " " + modeltag + " " + colltitle
            );

            $(".currenttagfit").html(yeartag + " " + maketag + " " + modeltag);

            $(".currcolltag").html(collprotitle);

            window.history.replaceState(
              {},
              null,
              curl +
                "?year=" +
                yeartag +
                "&make=" +
                maketag.replace("&", "%26") +
                "&model=" +
                modeltag.replace("&", "%26")
            );
            $(".search--button").removeAttr("disabled");

            $(".featured-swatch").click(function () {
              $(".featured-swatch").removeClass("active");
              $(this).addClass("active");
              $(".category-products-all").hide();
              $(
                '.category-products-all[data-handle="' +
                  $(this).data("handle") +
                  '"]'
              ).show();
            });
            $(".amfinder-reset").click(function () {
              window.location.href = curl;
            });
            $(".readmore").on("click", function () {
              var $content = $(this).parent();
              var isExpanded = $content.hasClass("expanded");

              if (isExpanded) {
                $content.removeClass("expanded");
                $(this).text("Read More");
              } else {
                $content.addClass("expanded");
                $(this).text("Read Less");
              }
            });
            $(".custom-product-color-item").click(function () {
              $(this)
                .parents(".custom-product-item-image-container")
                .find(".image img")
                .attr("src", $(this).data("image"));
            });
            var searchP = new URLSearchParams(window.location.search);
            var brandn = searchParams.get("brand");
            if (
              $('.swiper-slide.featured-swatch[data-handle="' + brandn + '"]')
                .length > 0
            ) {
              $(
                '.swiper-slide.featured-swatch[data-handle="' + brandn + '"]'
              ).trigger("click");
              $(".swiper-slide.featured-swatch").removeClass("active");
              $(
                '.swiper-slide.featured-swatch[data-handle="' + brandn + '"]'
              ).addClass("active");
            }
          } else {
            $(".after-reset").show();
            loadDataProduct();
            function loadDataProduct() {
              fetch("/collections/all/" + partn)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = responseText;
                  var elem = new DOMParser()
                    .parseFromString(html, "text/html")
                    .getElementsByClassName("after-reset")[0];
                  if (elem) {
                    var htmlmake = new DOMParser()
                      .parseFromString(html, "text/html")
                      .getElementsByClassName("after-reset")[0].innerHTML;
                    $(".after-reset").html(htmlmake);
                    $(".after-reset").css("text-align", "initial");
                    $(".category-products").click(function () {
                      $(this).next().toggle();
                      $(this).children(".header-box").toggleClass("opened");
                    });

                    $(".currenttag").html(
                      yeartag + " " + maketag + " " + modeltag + " " + colltitle
                    );

                    $(".currenttagfit").html(
                      yeartag + " " + maketag + " " + modeltag
                    );

                    $(".currcolltag").html(collprotitle);

                    window.history.replaceState(
                      {},
                      null,
                      curl +
                        "?year=" +
                        yeartag +
                        "&make=" +
                        maketag.replace("&", "%26") +
                        "&model=" +
                        modeltag.replace("&", "%26")
                    );
                    $(".search--button").removeAttr("disabled");

                    $(".featured-swatch").click(function () {
                      $(".featured-swatch").removeClass("active");
                      $(this).addClass("active");
                      $(".category-products-all").hide();
                      $(
                        '.category-products-all[data-handle="' +
                          $(this).data("handle") +
                          '"]'
                      ).show();
                    });
                    $("html, body").animate(
                      {
                        scrollTop: $("#richtext-collection").offset().top,
                      },
                      1500
                    );
                    var searchP = new URLSearchParams(window.location.search);
                    var brandn = searchParams.get("brand");
                    if (
                      $(
                        '.swiper-slide.featured-swatch[data-handle="' +
                          brandn +
                          '"]'
                      ).length > 0
                    ) {
                      $(
                        '.swiper-slide.featured-swatch[data-handle="' +
                          brandn +
                          '"]'
                      ).trigger("click");
                      $(".swiper-slide.featured-swatch").removeClass("active");
                      $(
                        '.swiper-slide.featured-swatch[data-handle="' +
                          brandn +
                          '"]'
                      ).addClass("active");
                    }
                    $(".amfinder-reset").click(function () {
                      window.location.href = curl;
                    });
                  } else {
                    loadDataProduct();
                  }

                  $(".readmore").on("click", function () {
                    var $content = $(this).parent();
                    var isExpanded = $content.hasClass("expanded");

                    if (isExpanded) {
                      $content.removeClass("expanded");
                      $(this).text("Read More");
                    } else {
                      $content.addClass("expanded");
                      $(this).text("Read Less");
                    }
                  });
                  $(".custom-product-color-item").click(function () {
                    $(this)
                      .parents(".custom-product-item-image-container")
                      .find(".image img")
                      .attr("src", $(this).data("image"));
                  });
                })
                .catch((error) => {
                  loadDataProduct();
                });
            }
          }

          if (yeartag != "" && maketag != "" && modeltag != "") {
            $(".amfinder-reset").show();
            $(".before-reset").hide();
            $(".after-reset").show();
            $(".view-all-cover").hide();
            $(".currenttag").html(
              yeartag + " " + maketag + " " + modeltag + " " + colltitle
            );
            $(".currenttagfit").html(yeartag + " " + maketag + " " + modeltag);
            $(".currcolltag").html(collprotitle);
          } else {
            $(".currenttag").html("100% Satisfaction Guarantee");
            $(".view-all-cover").show();
            $(".after-reset").hide();
            $(".before-reset").show();
            $(".amfinder-reset").hide();
          }
          $(".before-reset").css("opacity", 1);

          $(".amfinder-reset").click(function () {
            window.location.href = curl;
          });
        }
        window.addEventListener("beforeunload", function (e) {
          localStorage.setItem("afterdata", $(".after-reset").html());
          localStorage.setItem("year", $(".yearselect").val());
          localStorage.setItem("make", $(".makeselect").val());
          localStorage.setItem("model", $(".modelselect").val());
        });
        document.addEventListener("visibilitychange", () => {
          localStorage.setItem("afterdata", $(".after-reset").html());
          localStorage.setItem("year", $(".yearselect").val());
          localStorage.setItem("make", $(".makeselect").val());
          localStorage.setItem("model", $(".modelselect").val());
        });

        $(".before-reset").css("opacity", 1);
        $(".show_more_popup").click(function () {
          $(".mini-popup").show();
          $("html").css({ "overflow-x": "hidden", "overflow-y": "hidden" });
        });
        $(".btn-cancel").click(function () {
          $(".mini-popup").hide();
          $("html").css({ "overflow-x": "hidden", "overflow-y": "auto" });
        });
        $(".button-cover").click(function () {
          $(".mini-popup").show();
          $("html").css({ "overflow-x": "hidden", "overflow-y": "hidden" });
        });
      }
    }
  }
}

customElements.define("car-cover", CarCover);

class CarCoverLanding extends HTMLElement {
  constructor() {
    super();

    $(".before-reset").css("opacity", 1);
    $(".btn-cancel").click(function () {
      $(".mini-popup").hide();
      $("html").css({ "overflow-x": "hidden", "overflow-y": "auto" });
    });
    $(".show_more_popup").click(function () {
      $(".mini-popup").show();
      $("html").css({ "overflow-x": "hidden", "overflow-y": "hidden" });
    });
    var swiper = new Swiper(".custom-product-items-landing", {
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1401: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next-upsell",
        prevEl: ".swiper-button-prev-upsell",
      },
      pagination: {
        el: ".swiper-pagination-upsell",
      },
    });
    $(".custom-product-items-landing").css("opacity", "1");
  }
}

customElements.define("car-cover-landing", CarCoverLanding);

class ShopByStyleCover extends HTMLElement {
  constructor() {
    super();
    $(".featured-swatch").click(function () {
      $(".featured-swatch").removeClass("active");
      $(this).addClass("active");
      $(".category-products-all").hide();
      $(
        '.category-products-all[data-handle="' + $(this).data("handle") + '"]'
      ).show();
    });
    $(".morebutton").click(function () {
      $(this)
        .parent(".featured--search--subtitle")
        .css({ overflow: "visible", "-webkit-line-clamp": "unset" });
      $(this).hide();
      $(".lessbutton").show();
    });
    $(".lessbutton").click(function () {
      $(this)
        .parents(".featured--search--subtitle")
        .css({ overflow: "hidden", "-webkit-line-clamp": "2" });
      $(this).hide();
      $(".morebutton").show();
    });
  }
}

customElements.define("shop-by-style-cover", ShopByStyleCover);

class ShopByStyleLanding extends HTMLElement {
  constructor() {
    super();
    var collurl = $(this).data("collectionurl");
    $(this)
      .find(".cat-link-item")
      .click(function () {
        var handle = handleize($(this).data("tag"));
        window.location.href = collurl + "/" + handle;
      });

    function handleize(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
    }
  }
}

customElements.define("shop-by-style-landing", ShopByStyleLanding);

class HomeVideoBanner extends HTMLElement {
  constructor() {
    super();

    var csvurl = "";
    var jsonarr = [];
    $(this)
      .find(".catselect")
      .change(function () {
        jsonarr = [];
        csvurl = $(this).find("option:selected").attr("data-csv");
        console.log(csvurl);
        $(".yearselect").attr("disabled", "true");
        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["category"] = word_array[index][0];
              ob["year"] = word_array[index][1];
              ob["make"] = word_array[index][2];
              ob["model"] = word_array[index][3];
              ob["brand"] = word_array[index][4];
              jsonarr.push(ob);
            }
            setDataInPage(jsonarr);
          },
        });
      });

    function setDataInPage(jsonarr) {
      console.log("dsdsdsd");
      var strpart = $(".car-cover-main-container").data("strpart");
      var curl = $(".car-cover-main-container").data("url");
      var colltitle = $(".car-cover-main-container").data("title");
      var collprotitle = $(".car-cover-main-container").data("protitle");

      var years = [];
      $.each(jsonarr, function (index, value) {
        if ($.inArray(value.year, years) === -1) {
          years.push(value.year);
        }
      });
      loadData(years);

      function loadData(years) {
        years.sort();
        years.reverse();
        var stryear =
          '<option value="Select Year" disabled selected>Select Year</option>';
        for (var i = 0; i < years.length; i++) {
          var yy = years[i];
          stryear =
            stryear + `<option value='${yy}'>${yy.split("_")[1]}</option>`;
        }
        $(".yearselect").html(stryear);
        $(".yearselect").removeAttr("disabled");
        $(".modelselect").html(
          '<option value="Please Select" disabled selected>Select Model</option>'
        );
        $(".makeselect").html(
          '<option value="Please Select" disabled selected>Select Make</option>'
        );

        $(".yearselect").change(function () {
          $(".yearselect").val($(this).val());
          $(".amfinder-reset").show();

          $(".modelselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(".makeselect").html(
            '<option value="Please Select" disabled selected>Loading..</option>'
          );
          $(".modelselect").attr("disabled", "true");
          $(".makeselect").attr("disabled", "true");

          var makes = [];
          var selyear = $(this).val();
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.make, makes) === -1) {
              if (value.year == selyear) {
                makes.push(value.make);
              }
            }
          });
          makes.sort();
          var strmake =
            '<option value="Select Make" disabled selected>Select Make</option>';
          for (var i = 0; i < makes.length; i++) {
            var ma = makes[i];
            strmake =
              strmake +
              `<option value='${ma.replace(".", "")}'>${
                ma.split("_")[1]
              }</option>`;
          }
          $(".makeselect").html(strmake);
          $(".makeselect").removeAttr("disabled");
          $(".modelselect").html(
            '<option value="Select Model" disabled selected>Select Model</option>'
          );
          $(".modelselect").attr("disabled", true);
        });
        $(".makeselect").change(function () {
          $(".makeselect").val($(this).val());
          $(".amfinder-reset").show();
          console.log($(this).val());
          var models = [];
          var selyear = $(this)
            .parents(".select-wrapper")
            .find(".yearselect")
            .val();
          var selmake = $(this).val();
          $.each(jsonarr, function (index, value) {
            if ($.inArray(value.model, models) === -1) {
              if (value.year == selyear && value.make == selmake) {
                models.push(value.model);
              }
            }
          });
          models.sort();
          var modelhtml =
            '<option value="Select Model" disabled selected>Select Model</option>';
          for (var i = 0; i < models.length; i++) {
            console.log(models[i]);
            var mo = models[i];
            modelhtml =
              modelhtml +
              `<option value='${mo.replace(".", "")}'>${
                mo.split("_")[1]
              }</option>`;
          }
          $(".modelselect").html(modelhtml);
          $(".modelselect").removeAttr("disabled");
        });

        $(".modelselect").change(function () {
          $(".modelselect").val($(this).val());
          $(".search--button").removeAttr("disabled");
        });

        //$(".search--button").click(function ()
        $(".modelselect").change(function () {
          $(".modelselect").val($(this).val());
          var yearc = $(this)
            .parents(".select-wrapper")
            .find(".yearselect")
            .val()
            .replace(".", "")
            .replace("&", "%26")
            .toLowerCase();
          var makec = $(this)
            .parents(".select-wrapper")
            .find(".makeselect")
            .val()
            .replace(".", "")
            .replace("&", "%26")
            .toLowerCase();
          makec = makec.replace("/", "-");
          var modelc = $(this)
            .parents(".select-wrapper")
            .find(".modelselect")
            .val()
            .replace(".", "")
            .replace("&", "%26")
            .toLowerCase();
          var smodelc = modelc.split("/").join("-");
          var strpartn =
            yearc.split(" ").join("-") +
            "+" +
            makec.split(" ").join("-") +
            "+" +
            smodelc.split(" ").join("-");
          var handle = $(this)
            .parents(".select-wrapper")
            .find(".catselect")
            .val();
          var redurl =
            "/collections/" +
            handle +
            "?year=" +
            yearc.split("_")[1] +
            "&make=" +
            makec.split("_")[1] +
            "&model=" +
            modelc.split("_")[1];
          localStorage.clear();
          window.location.href = redurl;
        });
      }
    }
  }
}

customElements.define("home-video-banner", HomeVideoBanner);

class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".thumb-slider", {
        spaceBetween: 10,
        slidesPerView: 3,
        navigation: {
          nextEl: ".swiper-button-next-thumb",
          prevEl: ".swiper-button-prev-thumb",
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
      });
      var swiper2 = new Swiper(".main-slider", {
        slidesPerView: 1.1,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        spaceBetween: 10,
      });
      $(".thumb-slider .swiper-slide:visible").eq(0).addClass("active");
      $(".thumb-img").click(function () {
        var count = 0;
        var cindex = 0;
        var mediaindex = $(this).parent().data("index");
        $(".thumb-slider .swiper-slide").removeClass("active");
        $(this).parent().addClass("active");
        $(".main-slider .swiper-slide:visible").each(function (index) {
          if ($(this).data("index") == mediaindex) {
            cindex = count;
          }
          count++;
        });
        swiper2.slideTo(cindex);
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-slider", CustomSlider);

class ProductDescriptionTabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".tabs-stage .tabcontent").hide();
      $(".tabs-stage .tabcontent:first").show();
      $(".tabs-nav .tabtitle:first").addClass("tab-active");

      // Change tab class and display content
      $(".tabs-nav a").on("click", function (event) {
        event.preventDefault();
        $(".tabs-nav .tabtitle").removeClass("tab-active");
        $(this).parent().addClass("tab-active");
        $(".tabs-stage .tabcontent").hide();
        $($(this).attr("href")).show();
      });
      $(".fyi-accordion").click(function () {
        var isactive = $(this).hasClass("active");
        $(".fyi-accordion").removeClass("active");
        $(".fyi-accordion .minus").hide();
        $(".fyi-accordion .plus").show();
        $(".fyi-panel").hide();
        if (!isactive) {
          $(this).addClass("active");
          $(this).find(".minus").show();
          $(this).find(".plus").hide();
          $(this).parent().find(".fyi-panel").show();
        }
      });

      $(".description-tab").click(function () {
        $(".tabs-nav .tabtitle").removeClass("tab-active");
        $(".tabs-stage .tabcontent").hide();
        $(
          '.tabs-stage .tabcontent[data-title="' + $(this).data("title") + '"]'
        ).show();
        $(
          '.tabs-nav .tabtitle[data-title="' + $(this).data("title") + '"]'
        ).addClass("tab-active");

        if ($(this).data("innertitle") != "") {
          $(".fyi-accordion").removeClass("active");
          $(".fyi-panel").hide();
          $(".fyi-accordion .minus").hide();
          $(".fyi-accordion .plus").show();
          $(
            '.fyi-accordion-item[data-innertitle="' +
              $(this).data("innertitle") +
              '"]'
          )
            .find(".fyi-accordion")
            .addClass("active");
          $(
            '.fyi-accordion-item[data-innertitle="' +
              $(this).data("innertitle") +
              '"]'
          )
            .find(".fyi-panel")
            .show();
          $(
            '.fyi-accordion-item[data-innertitle="' +
              $(this).data("innertitle") +
              '"]'
          )
            .find(".plus")
            .hide();
          $(
            '.fyi-accordion-item[data-innertitle="' +
              $(this).data("innertitle") +
              '"]'
          )
            .find(".minus")
            .show();

          var this2 = this;
          $("html, body").animate(
            {
              scrollTop:
                $(
                  '.fyi-accordion-item[data-innertitle="' +
                    $(this2).data("innertitle") +
                    '"]'
                ).offset().top - 50,
            },
            500
          );
        } else {
          var this2 = this;
          $("html, body").animate(
            {
              scrollTop: $("product-description-tab").offset().top,
            },
            500
          );
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-description-tab", ProductDescriptionTabs);

class FabricImageSlides extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var sectionid = $(this)
        .find(".main-fabric-slider-section")
        .data("sectionid");
      console.log("#" + sectionid);
      var swiper = new Swiper("#" + sectionid + " .fabric-image-slider", {
        slidesPerView: 1,
        navigation: {
          nextEl:
            "#" +
            sectionid +
            " .fabric-image-slider .swiper-button-next-fabric",
          prevEl:
            "#" +
            sectionid +
            " .fabric-image-slider .swiper-button-prev-fabric",
        },
        pagination: {
          el: ".swiper-pagination-fabric",
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("fabric-image-sliders", FabricImageSlides);

class producttestimonials extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(".Product-testimonial-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        pagination: {
          el: ".product-testimonial-pagination",
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-testimonials", producttestimonials);

class Customfaqmain extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-heading")
        .unbind()
        .click(function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });
          } else {
            $this.parent().parent().find(".faq-content").removeClass("show");
            $this.parent().parent().find(".faq-content").slideUp(350);

            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "none" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "flex" });
          }

          $(".custom-collapsible-inner-content").css({ display: "none" });
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-faq-main", Customfaqmain);

class productbanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        if ($(document).width() < 990) {
          $(".mobile-play-button").click(function () {
            $(this).parents(".mobilemedia").find("img").hide();
            $(this).parents(".mobilemedia").find("video").get(0).play();
            $(this).data("play", "true");
            $(this).hide();
          });

          $(".mobile-pause-button").click(function () {
            $(this).parents(".mobilemedia").find("img").show();
            $(this).parents(".mobilemedia").find("video").get(0).pause();
            $(this).hide();
            $(this).parents(".mobilemedia").find(".mobile-play-button").show();
            $(this)
              .parents(".mobilemedia")
              .find(".mobile-play-button")
              .data("show");
            $(this)
              .parents(".mobilemedia")
              .find(".mobile-play-button")
              .data("play", "false");
          });

          $(".product-banner-container").mousemove(function (event) {
            var play = $(this)
              .find(".mobilemedia")
              .find(".mobile-play-button")
              .data("play");
            if (play == "true") {
              $(this).find(".mobilemedia").find(".mobile-pause-button").show();
            }
          });

          $(".product-banner-container").mouseenter(function (event) {
            var play = $(this)
              .find(".mobilemedia")
              .find(".mobile-play-button")
              .data("play");
            if (play == "true") {
              $(this).find(".mobilemedia").find(".mobile-pause-button").show();
            }
          });

          $(".product-banner-container").mouseleave(function (event) {
            var play = $(this)
              .find(".mobilemedia")
              .find(".mobile-play-button")
              .data("play");
            if (play == "true") {
              $(this).find(".mobilemedia").find(".mobile-pause-button").hide();
            }
          });
        } else {
          $(".desktop-play-button").click(function () {
            $(this).parents(".desktopmedia").find(".thumbnails").hide();
            $(this).parents(".desktopmedia").find("video").get(0).play();
            $(this).data("play", "true");
            $(this).hide();
          });
          $(".desktop-pause-button").click(function () {
            $(this).parents(".desktopmedia").find(".thumbnails").show();
            $(this).parents(".desktopmedia").find("video").get(0).pause();
            $(this).hide();
            $(this)
              .parents(".desktopmedia")
              .find(".desktop-play-button")
              .show();
            $(this)
              .parents(".desktopmedia")
              .find(".desktop-play-button")
              .data("show");
            $(this)
              .parents(".desktopmedia")
              .find(".desktop-play-button")
              .data("play", "false");
          });
          $(".product-banner-container").mousemove(function (event) {
            var play = $(this)
              .find(".desktopmedia")
              .find(".desktop-play-button")
              .data("play");
            if (play == "true") {
              $(this)
                .find(".desktopmedia")
                .find(".desktop-pause-button")
                .show();
            }
          });

          $(".product-banner-container").mouseenter(function (event) {
            var play = $(this)
              .find(".desktopmedia")
              .find(".desktop-play-button")
              .data("play");
            if (play == "true") {
              $(this)
                .find(".desktopmedia")
                .find(".desktop-pause-button")
                .show();
            }
          });

          $(".product-banner-container").mouseleave(function (event) {
            var play = $(this)
              .find(".desktopmedia")
              .find(".desktop-play-button")
              .data("play");
            if (play == "true") {
              $(this)
                .find(".desktopmedia")
                .find(".desktop-pause-button")
                .hide();
            }
          });
        }
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-banner", productbanner);

class faqsectionhelp extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-heading")
        .unbind()
        .click(function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });
          } else {
            $this.parent().parent().find(".faq-content").removeClass("show");
            $this.parent().parent().find(".faq-content").slideUp(350);

            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "none" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "flex" });
          }

          $(".custom-collapsible-inner-content").css({ display: "none" });
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("faq-section-help", faqsectionhelp);

class landingTestimonial extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".testimonial-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next.testimonial-swiper-button-next",
          prevEl: ".swiper-button-prev.testimonial-swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1440: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("landing-testimonial", landingTestimonial);

class logoslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".logo-slider", {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        freeMode: true,
        speed: 3000,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("logo-slider", logoslider);

class imageslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".image-slider-landing", {
        slidesPerView: 2,
        spaceBetween: 10,
        // freeMode: true,
        // speed:3000,
        // autoplay: {
        //   delay: 1,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".image-slider-landing .swiper-button-next",
          prevEl: ".image-slider-landing .swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("image-slider", imageslider);

class HomeTextBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var desktop_cont = $(".testimonials-slider")
        .find(".swiper-wrapper")
        .attr("desktop-slide");
      var speed = $(".testimonials-slider")
        .find(".swiper-wrapper")
        .attr("speed");
      var slideplay = $(".testimonials-slider")
        .find(".swiper-wrapper")
        .attr("slideautoplay");
      var swiper = new Swiper(".testimonials-slider", {
        spaceBetween: 30,
        // loop:true,
        breakpoints: {
          990: {
            slidesPerView: desktop_cont,
            spaceBetween: 20,
          },
        },
        slidesPerView: 1,
        autoplay: {
          delay: speed,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      if (slideplay == "true") {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("home-text-banner", HomeTextBanner);

class richtextcollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      var swiper = new Swiper(".richtext-collection-slider", {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1850: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("richtext-collection", richtextcollection);

class CarCoverStyle extends HTMLElement {
  constructor() {
    super();
    $(".featured-swatch").click(function () {
      console.log("test");
      $(".featured-swatch").removeClass("active");
      $(this).addClass("active");
      $(".category-products-all").hide();
      $(
        '.category-products-all[data-handle="' + $(this).data("handle") + '"]'
      ).show();
    });
  }
}

customElements.define("car-covers-style", CarCoverStyle);

class customsectionaccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".custom-accordion-container")
        .unbind()
        .click(function (e) {
          e.preventDefault();

          let $this = $(this);

          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });
          } else {
            $this
              .parent()
              .parent()
              .find(".accordian-content")
              .removeClass("show");
            $this.parent().parent().find(".accordian-content").slideUp(350);

            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "flex" });
            $this
              .parent()
              .parent()
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "none" });

            $this.next().toggleClass("show");
            $this.next().slideToggle(350);

            $this
              .find(".faq-icon-container")
              .find(".faqplus")
              .css({ display: "none" });
            $this
              .find(".faq-icon-container")
              .find(".faqminus")
              .css({ display: "flex" });
          }

          $(".custom-collapsible-inner-content").css({ display: "none" });
        });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-section-accordion", customsectionaccordion);

$(".custom-product-color-item").click(function () {
  $(this)
    .parents(".custom-product-item-image-container")
    .find(".image img")
    .attr("src", $(this).data("image"));
});

class CustomReviews extends HTMLElement {
  constructor() {
    super();

    this.initAnchor();
  }

  initAnchor() {
    var this2 = this;
    $(".custom-pagination a").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      this2.loadReviewData($(this).attr("href"));
    });
  }

  loadReviewData(url) {
    var this2 = this;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        var elem = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementsByClassName("custom-reviews-container")[0];
        $(".custom-reviews-container").html($(elem).html());
        this2.initAnchor();
      })
      .catch((error) => {
        this2.loadProductData(url);
      });
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.initAnchor();
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-reviews", CustomReviews);

// class mainproductmockup extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
//       var url_string = window.location.href;
//       var url = new URL(url_string);
//       var make = url.searchParams.get("make");
//       var model = url.searchParams.get("model");
//       var year = url.searchParams.get("year");
//       var csvurl = $(this).data("csvurl");
//       var handle = $(this).data("landingcoll");
//       var landingurl = $(this).data("landingpage");
//       var jsonarr = [];

//       if (url.searchParams.get("model") && url.searchParams.get("make")) {
//       } else {
//         window.location.href = landingurl;
//       }

//       $(".yearselect").attr("disabled", "true");
//       $.ajax({
//         type: "GET",
//         url: csvurl,
//         dataType: "text",
//         success: function (data) {
//           var csvData = data;
//           let word_array = $.csv.toArrays(csvData);

//           for (let index = 1; index < word_array.length; index++) {
//             var ob = {};
//             ob["category"] = word_array[index][0];
//             ob["year"] = word_array[index][1];
//             ob["make"] = word_array[index][2];
//             ob["model"] = word_array[index][3];
//             ob["title"] = word_array[index][4];
//             ob["images"] = word_array[index][5];
//             ob["instock"] = word_array[index][6];
//             ob["price"] = word_array[index][7];
//             ob["compprice"] = word_array[index][8];
//             ob["tags"] = word_array[index][9];
//             jsonarr.push(ob);
//           }
//           setSelectTags(jsonarr);
//         },
//       });

//       function setSelectTags(jsonarr) {
//         var maketag = "MAKE_" + make.toUpperCase();
//         var modeltag = "MODEL_" + model.toUpperCase();

//         var strmake = "";
//         strmake =
//           strmake +
//           `<option value='${maketag.replace(".", "")}'>${
//             maketag.split("_")[1]
//           }</option>`;

//         $(".makeselect").html(strmake);
//         $(".makeselect").removeAttr("disabled");

//         var modelhtml = "";

//         modelhtml =
//           modelhtml +
//           `<option value='${modeltag.replace(".", "")}'>${
//             modeltag.split("_")[1]
//           }</option>`;

//         $(".modelselect").html(modelhtml);
//         $(".modelselect").removeAttr("disabled");

//         var years = [];

//         var datasearch = {};

//         var found = false;

//         $.each(jsonarr, function (index, value) {
//           if ($.inArray(value.year, years) === -1) {
//             if (
//               value.make.toUpperCase() == maketag &&
//               value.model.toUpperCase() == modeltag
//             ) {
//               years.push(value.year);
//               datasearch = value;
//               found = true;
//             }
//           }
//         });
//         console.log(maketag);
//         console.log(modeltag);
//         console.log(datasearch);

//         if (found == false) {
//           window.location.href = landingurl;
//         }

//         years.sort();

//         var yearhtml =
//           '<option value="Select Year" disabled selected>Select Year</option>';
//         for (var i = 0; i < years.length; i++) {
//           var ye = years[i];
//           yearhtml =
//             yearhtml +
//             `<option value='${ye.replace(".", "")}'>${
//               ye.split("_")[1]
//             }</option>`;
//         }
//         $(".yearselect").html(yearhtml);
//         $(".yearselect").removeAttr("disabled");

//         $(".yearselect").change(function () {
//           $(".yearselect").val($(this).val());
//           var yearc = $(this)
//             .parents(".select-wrapper")
//             .find(".yearselect")
//             .val()
//             .replace(".", "")
//             .replace("&", "%26")
//             .toLowerCase();
//           var makec = $(this)
//             .parents(".select-wrapper")
//             .find(".makeselect")
//             .val()
//             .replace(".", "")
//             .replace("&", "%26")
//             .toLowerCase();
//           makec = makec.replace("/", "-");
//           var modelc = $(this)
//             .parents(".select-wrapper")
//             .find(".modelselect")
//             .val()
//             .replace(".", "")
//             .replace("&", "%26")
//             .toLowerCase();
//           var smodelc = modelc.split("/").join("-");
//           var strpartn =
//             yearc.split(" ").join("-") +
//             "+" +
//             makec.split(" ").join("-") +
//             "+" +
//             smodelc.split(" ").join("-");

//           var redurl =
//             "/collections/" +
//             handle +
//             "?year=" +
//             yearc.split("_")[1] +
//             "&make=" +
//             makec.split("_")[1] +
//             "&model=" +
//             modelc.split("_")[1];
//           localStorage.clear();
//           window.location.href = redurl;
//         });
//         setDataInPage(datasearch);
//       }

//       function setDataInPage(datasearch) {
//         var strpart = $(".car-cover-main-container").data("strpart");
//         var curl = $(".car-cover-main-container").data("url");
//         var colltitle = $(".car-cover-main-container").data("title");
//         var collprotitle = $(".car-cover-main-container").data("protitle");
//         loadData();

//         function loadData() {
//           $(".custom-collapsible-title").each(function () {
//             var text = $(this).html();
//             text = text.split("$make").join(datasearch.make.split("_")[1]);
//             text = text.split("$model").join(datasearch.model.split("_")[1]);
//             text = text
//               .split("$category")
//               .join(datasearch.category.split("_")[1]);
//             $(this).html(text);
//           });
//           $(".custom-collapsible-content").each(function () {
//             var text = $(this).html();
//             text = text.split("$make").join(datasearch.make.split("_")[1]);
//             text = text.split("$model").join(datasearch.model.split("_")[1]);
//             text = text
//               .split("$category")
//               .join(datasearch.category.split("_")[1]);
//             $(this).html(text);
//           });

//           $(".custom-collapsible-title")
//             .unbind()
//             .click(function (e) {
//               e.preventDefault();
//               let $this = $(this);
//               if ($this.next().hasClass("show")) {
//                 $this.next().removeClass("show");
//                 $this.next().slideUp(350);
//                 $(".custom-collapsible-title ").removeClass("active");
//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".plus")
//                   .css({ display: "flex" });
//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".minus")
//                   .css({ display: "none" });
//               } else {
//                 $this
//                   .parent()
//                   .parent()
//                   .find(".custom-collapsible-title")
//                   .removeClass("active");

//                 $this
//                   .parent()
//                   .parent()
//                   .find(".custom-collapsible-content")
//                   .removeClass("show");
//                 $this
//                   .parent()
//                   .parent()
//                   .find(".custom-collapsible-content")
//                   .slideUp(350);

//                 $this
//                   .parent()
//                   .parent()
//                   .find(".collapsible-icon-container")
//                   .find(".plus")
//                   .css({ display: "flex" });
//                 $this
//                   .parent()
//                   .parent()
//                   .find(".collapsible-icon-container")
//                   .find(".minus")
//                   .css({ display: "none" });
//                 $this.toggleClass("active");
//                 $this.next().toggleClass("show");
//                 $this.next().slideToggle(350);

//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".plus")
//                   .css({ display: "none" });
//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".minus")
//                   .css({ display: "flex" });
//               }

//               $(".custom-collapsible-inner-content").css({ display: "none" });
//             });

//           $(".custom-collapsible-inner-title")
//             .unbind()
//             .click(function (e) {
//               e.preventDefault();

//               let $this = $(this);

//               if ($this.next().hasClass("show")) {
//                 $this.next().removeClass("show");
//                 $this.next().slideUp(350);

//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".plus")
//                   .css({ display: "flex" });
//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".minus")
//                   .css({ display: "none" });
//               } else {
//                 $this
//                   .parent()
//                   .parent()
//                   .find(".custom-collapsible-inner-content")
//                   .removeClass("show");
//                 $this
//                   .parent()
//                   .parent()
//                   .find(".custom-collapsible-inner-content")
//                   .slideUp(350);

//                 $this
//                   .parent()
//                   .parent()
//                   .find(".collapsible-icon-container")
//                   .find(".plus")
//                   .css({ display: "flex" });
//                 $this
//                   .parent()
//                   .parent()
//                   .find(".collapsible-icon-container")
//                   .find(".minus")
//                   .css({ display: "none" });

//                 $this.next().toggleClass("show");
//                 $this.next().slideToggle(350);

//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".plus")
//                   .css({ display: "none" });
//                 $this
//                   .find(".collapsible-icon-container")
//                   .find(".minus")
//                   .css({ display: "flex" });
//               }
//             });

//           var price = Number(datasearch.price);
//           var compprice = Number(datasearch.compprice);

//           if (compprice > price) {
//             $(".customproductprice").html(
//               "$" + price.toFixed(2).replace(/\.00$/, "")
//             );
//             $(".customproductcompprice").html(
//               "$" + compprice.toFixed(2).replace(/\.00$/, "")
//             );
//             var sav = parseInt(((compprice - price) * 100) / compprice);
//             $(".custom-product-price-info span").html(
//               `SAVE ${sav}% + FREE SHIPPING`
//             );
//           } else {
//             $(".custom-product-price-info").hide();
//             $(".customproductcompprice").hide();
//           }
//           if (datasearch.instock == "1") {
//             $(".ready-to-ship").show();
//             $(".made-to-order").hide();
//           } else {
//             $(".ready-to-ship").hide();
//             $(".made-to-order").show();
//           }
//           $(".main_product_title").html(`<div>${datasearch.title}</div>`);
//           if (datasearch.instock == "1") {
//             $(".shiptype").html("Ready to ship");
//           } else {
//             $(".shiptype").html("Made to order");
//           }
//           $(".currenttagfits").html(` For <b>${make} ${model}<b>`);
//           $(".main_product_title").html(`<div>${datasearch.title}</div>`);

//           var images = datasearch.images.split(",");

//           var imagestr = "";
//           var imagestrthumb = "";
//           for (var ind = 0; ind < images.length; ind++) {
//             imagestr =
//               imagestr +
//               `<div class="swiper-slide" data-index="${ind}" >
//                             <img class="pr-img" src="//bestcovers.com/cdn/shop/files/${images[ind]}.jpg" alt="${make} ${model}">
//                           </div>`;
//             imagestrthumb =
//               imagestrthumb +
//               `<div class="swiper-slide" data-index="${ind}" >
//                             <img class="thumb-img" src="//bestcovers.com/cdn/shop/files/${images[ind]}.jpg" alt="${make} ${model}">
//                           </div>`;
//           }

//           $(".thumb-slider .swiper-wrapper").html(imagestrthumb);
//           $(".main-slider .swiper-wrapper").html(imagestr);

//           var swiper = new Swiper(".thumb-slider", {
//             spaceBetween: 10,
//             slidesPerView: 3,
//             navigation: {
//               nextEl: ".swiper-button-next-thumb",
//               prevEl: ".swiper-button-prev-thumb",
//             },
//             breakpoints: {
//               640: {
//                 slidesPerView: 3,
//                 spaceBetween: 10,
//               },
//               768: {
//                 slidesPerView: 4,
//                 spaceBetween: 10,
//               },
//               1024: {
//                 slidesPerView: 5,
//                 spaceBetween: 10,
//               },
//             },
//           });
//           var swiper2 = new Swiper(".main-slider", {
//             slidesPerView: 1.1,
//             breakpoints: {
//               768: {
//                 slidesPerView: 1,
//                 spaceBetween: 10,
//               },
//             },
//             spaceBetween: 10,
//           });
//           $(".thumb-slider .swiper-slide:visible").eq(0).addClass("active");
//           $(".thumb-img").click(function () {
//             var count = 0;
//             var cindex = 0;
//             var mediaindex = $(this).parent().data("index");
//             $(".thumb-slider .swiper-slide").removeClass("active");
//             $(this).parent().addClass("active");
//             $(".main-slider .swiper-slide:visible").each(function (index) {
//               if ($(this).data("index") == mediaindex) {
//                 cindex = count;
//               }
//               count++;
//             });
//             swiper2.slideTo(cindex);
//           });

//           var tags = datasearch.tags.split(",");

//           var tagstr = "";
//           for (var ind = 0; ind < tags.length; ind++) {
//             tagstr =
//               tagstr +
//               `<div class="tag-name" bis_skin_checked="1">${tags[ind]}</div>`;
//           }
//           $(".tag-container").html(tagstr);

//           setTimeout(function () {
//             $(".loading-page").css("display", "none");
//             $("main-product-mockup section").css("display", "block");
//           }, 1000);

//           console.log("tesst");
//         }
//       }
//     };
//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }

// customElements.define("main-product-mockup", mainproductmockup);

// $(".custom_product_main_wrapper custom-collapsible-mock-tab")
//   .eq(0)
//   .find(".custom-collapsible-title")
//   .click();
